import { takeEvery } from 'modules/typed-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionMarketplaceGet } from './actions';

export const sagasMarketplace = [
  takeEvery([actionMarketplaceGet.rejected], workerErrorNotifyThunk),
];
